import { render, staticRenderFns } from "./AddGroupComponent.vue?vue&type=template&id=367175f0&"
import script from "./AddGroupComponent.vue?vue&type=script&lang=js&"
export * from "./AddGroupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports